import * as React from 'react';
import * as ReactDOM from 'react-dom';
import WishlistPublicContainer from '../../Components/WishlistPublic/Container/WishlistPublicContainer';

export default function PublicWatchlistIntegration() {
    const publicWishlistDomContainer = document.getElementById('js-wishlist-public-view');

    if (publicWishlistDomContainer) {
        const shortUri = publicWishlistDomContainer.dataset.shortUri || '';
        return (
            <>{ReactDOM.createPortal(<WishlistPublicContainer shortUri={shortUri} />, publicWishlistDomContainer)};</>
        );
    }

    return null;
}
